import React from 'react';
import { connect } from 'react-redux';
import generalHelpers from 'utils/generalHelpers';

interface ComponentAccessCheck {
    children?: React.ReactNode;
    permission: string;
    session: any;
    /**
     * When true, also check `session.special_rights` in addition to `session.permissions`.
     * Defaults to `false` to preserve existing behavior.
     */
    checkSpecialPermissions?: boolean;
}

const mapStateToProps = (state: any) => {
    return {
        session: state.session,
    };
};

const ComponentAccessCheck: React.FC<ComponentAccessCheck> = ({
    children,
    permission,
    session,
    checkSpecialPermissions = false,
}) => {
    const renderComponent = (): React.ReactNode | null => {
        const canHavePermissions =
            Array.isArray(session?.permissions) &&
            generalHelpers.hasPermissions(session, permission);
        const canHaveSpecialPermissions =
            checkSpecialPermissions &&
            Array.isArray(session?.special_rights) &&
            generalHelpers.hasSpecialPermissions(session, permission);

        if (canHavePermissions || canHaveSpecialPermissions) {
            return children ?? null;
        }

        return null;
    };

    return <>{renderComponent()}</>;
};

export default connect(mapStateToProps)(ComponentAccessCheck);
